<template>
  <div>
    <v-row class="cont">
      <v-col cols="12" md="6" lg="4" v-if="user_card_id">
        <h2 class="text-left mb-4">Скоринг</h2>
        <v-btn @click="openDialog" color="primary">Анализ</v-btn>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <h3 class="text-left mb-4">КАТМ</h3>
        <div class="d-flex flex-wrap ma-n1 flex-column flex-sm-row">
          <div class="pa-1">
            <v-btn :width="$vuetify.breakpoint.smAndDown ? '100%' : null" small :to="{name: 'user-info', params: {creditId: credit_id}}" target="_blank" color="primary">
              Получить
              кредитную истоию
            </v-btn>
          </div>
          <div class="pa-1">
            <v-btn :width="$vuetify.breakpoint.smAndDown ? '100%' : null" small :to="{name: 'user-salary-info', params: {creditId: credit_id}}" target="_blank"
                   color="primary darken-2">Получить сведении о доходах
            </v-btn>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <div v-if="parseInt(initial) === 0">
          <h2 class="text-left mb-4">Активировать кредит</h2>
          <div class="d-flex ma-n1 flex-wrap">
            <div class="pa-1">
              <v-btn color="success" class="mr-2" @click="showConfirmDialogHandler">Активировать</v-btn>
            </div>
            <div class="pa-1">
              <v-btn color="error" class="mr-2" @click="showRejectDialogHandler">Отменить</v-btn>
            </div>
          </div>
        </div>
        <div v-else>
          <h2 class="text-left mb-4">Сохранить</h2>
          <div class="d-flex ma-n2 flex-wrap flex-column flex-sm-row">
            <div class="pa-2">
              <v-btn :width="$vuetify.breakpoint.smAndDown ? '100%' : null" color="success" class="mr-2" @click="$router.push('/credits/' +  credit_id)">Перейти в кредит
              </v-btn>
            </div>
            <div class="pa-2">
              <v-btn :width="$vuetify.breakpoint.smAndDown ? '100%' : null" color="error" class="mr-2" @click="showRejectDialogHandler">Отменить</v-btn>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <reject-credit-dialog
        @submit="rejectCredit"
        v-model="rejectDialog"
    ></reject-credit-dialog>
    <scoring-by-token
        v-model="scoringDialog"
        :user_card_id="user_card_id"
        :amount="amount"
        :initial="initial"
        :firstPayment="firstPayment"
    ></scoring-by-token>
    <confirm-credit-dialog
        :confirmMessage="confirmMessage"
        ref="confirmDialog"
        :credit_id="credit_id"
        :reSend="showConfirmDialogHandler"
        :phone="phone"
        @confirmed="$router.push({name: 'credit-index'})"
        v-model="confirmDialog"></confirm-credit-dialog>

  </div>
</template>

<script>
import RejectCreditDialog from "@/components/credit/RejectCreditDialog";
import {messages} from "@/utils/constants";
import ConfirmCreditDialog from "@/components/credit/ConfirmCreditDialog";
import ScoringByToken from "./ScoringByToken";

export default {
  props: {
    credit_id: {},
    phone: {},
    user_card_id: {},
    amount: {},
    initial: {},
    firstPayment: null,
  },
  components: {ScoringByToken, ConfirmCreditDialog, RejectCreditDialog},
  data() {
    return {
      scoringDialog: false,
      rejectDialog: false,
      confirmDialog: false,
      confirmMessage: null
    }
  },
  methods: {
    showRejectDialogHandler() {
      this.rejectDialog = true
    },
    openDialog() {
      this.scoringDialog = true;
    },
    async showConfirmDialogHandler() {
      this.$showLoading()
      try {
        const {data: {data: {message}}} = await this.$http.post(`admin/credits/create/activate/${this.credit_id}`)
        this.$setSuccess({text: messages['onConfirmedCredit']});
        this.onConfirmed();
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
    onConfirmed() {
      this.$router.push({name: 'credit-index'})
    },
    async rejectCredit(comment) {
      this.$showLoading()
      try {
        const data = await this.$http.post(`admin/credits/create/cancel/${this.credit_id}`, {
          comment
        })
        this.rejectDialog = false
        this.$setSuccess({text: messages.onRejectedCredit})
        await this.$router.push({name: 'credit-index'})
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },

  }
}
</script>
<style>
.cont {
  min-height: 400px;
}
</style>
